/**
 * Günün metresi (mobil TerakkimMeter ile aynı kurallar): seçili gündeki
 * adımlar (hedefler, hatim, müzakere) dilim dilim dolar. O gün olmayan adım
 * gösterilmez (null). Değerler 0..1.
 */
import { computeMemberProgress } from "./hatimProgress";
import { goalValueIn } from "./dayGoals";

const clamp = (n) => Math.min(1, Math.max(0, Number(n) || 0));

/** Hedefler: her hedefin tamamlanma oranı (fazlası sayılmaz) ortalaması. */
export function goalsProgress(goals, values) {
  const counted = (goals || []).filter((g) => (Number(g.goalValue) || 0) > 0);
  if (counted.length === 0) return null;
  const sum = counted.reduce(
    (acc, g) => acc + clamp(goalValueIn(values, g) / Number(g.goalValue)),
    0
  );
  return sum / counted.length;
}

/** Hatim: o gündeki hatimlerde payımın okunma oranı ortalaması. */
export function hatimDayProgress(instances) {
  const withShare = (instances || []).filter((i) => i && i.myAssignment);
  const rows = withShare
    .map((i) => computeMemberProgress(i.myAssignment, i.type))
    .filter((p) => p.assignedAmount > 0);
  if (rows.length === 0) return null;
  return rows.reduce((acc, p) => acc + clamp(p.completedAmount / p.assignedAmount), 0) / rows.length;
}

/**
 * Müzakere: o günün planlı müzakerelerinden katılınanların payı. Ay kaydında
 * muzakereDates (her müzakere için tarih) ve günün etkinliklerinde muzakereId var.
 */
export function muzakereDayProgress(month, date) {
  const planned = (month?.muzakereDates || []).filter((d) => d === date).length;
  const day = (month?.dailyLogs || []).find((d) => d?.date === date);
  const events = day?.events || day?.log?.dailyEvents || [];
  const attended = events.filter((e) => e && e.muzakereId).length;
  const total = Math.max(planned, attended);
  if (total === 0) return null;
  return clamp(attended / total);
}

const STEP_META = {
  goals: { labelKey: "Hedefler" },
  hatim: { labelKey: "Hatim" },
  muzakere: { labelKey: "Müzakere" },
};

/** Dilimler: olmayan adım çıkar; en çok ilerleyen başta, eşitlikte sıra korunur. */
export function buildMeterSteps({ goals, hatim, muzakere }) {
  return [
    ["goals", goals],
    ["hatim", hatim],
    ["muzakere", muzakere],
  ]
    .filter(([, p]) => p !== null && p !== undefined)
    .map(([key, p], i) => ({ key, label: STEP_META[key].labelKey, progress: clamp(p), i }))
    .sort((a, b) => b.progress - a.progress || a.i - b.i)
    .map(({ i, ...step }) => step);
}

export function meterTotal(steps) {
  if (!steps || steps.length === 0) return 0;
  return steps.reduce((acc, s) => acc + clamp(s.progress), 0) / steps.length;
}

export function meterComplete(steps) {
  return Boolean(steps && steps.length > 0 && steps.every((s) => s.progress >= 1));
}

/**
 * Kalemin durduğu nokta (0..1, dilim şeridi boyunca): bitmemiş ilk dilimin
 * dolan ucu. Hepsi bittiyse null.
 */
export function pencilPosition(steps, gapRatio = 0) {
  const n = steps?.length || 0;
  const current = (steps || []).findIndex((s) => s.progress < 1);
  if (n === 0 || current < 0) return null;
  const segment = (1 - gapRatio * (n - 1)) / n;
  return current * (segment + gapRatio) + segment * clamp(steps[current].progress);
}
